import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBOdfpGGA_qvNWQ1ovVD1beiJaM5wvLEOk",
  authDomain: "apni-gaadi-2026.firebaseapp.com",
  projectId: "apni-gaadi-2026",
  storageBucket: "apni-gaadi-2026.firebasestorage.app",
  messagingSenderId: "196206425243",
  appId: "1:196206425243:web:99b8d98d304e3473e4c23e",
  measurementId: "G-LKG7RPE6J1",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
